export enum TransactionEnum {
  MINT = 'mint',
  COLLECT_ALL = 'collectAll',
  MERGE = 'merge',
  MINT_SOULBOUND = 'mint_soulbound',
  WHITELIST = 'whitelist',
  REDEEM_MANY = 'redeemMany',
}
